import {CanActivateFn} from "@angular/router";
import {inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {selectTenantRoleData} from "../../shared/state/auth/auth.selectors";
import {filter, map} from "rxjs/operators";
import {TenantRole} from "../../shared/models/tenant-role.model";

export const userManagementAuthGuard: CanActivateFn = () => {
  const store = inject(Store);

  // Wait for tenantRoleData to be loaded (bs-top-navigation handles the dispatch)
  return store.select(selectTenantRoleData).pipe(
    filter((tenantRoleData: TenantRole | null) => !!tenantRoleData && !!tenantRoleData?.role),
    map(() => true)
  );
};
